import type { Printable } from '../domain/Printable';
import type { AttentionStatusType } from './AttentionStatus';
import type { EvaluationRule } from './EvaluationRule';

export type EvaluatedResult<T extends Printable> = {
  value: T;
  status: AttentionStatusType;
};

export type EvaluationResultType<T extends Printable> = EvaluatedResult<T> & {
  ruleName: EvaluationRule['calculationProperty'];
  toEvaluatedResult: () => EvaluatedResult<T>;
};

export class EvaluationResult<T extends Printable>
  implements EvaluationResultType<T>
{
  private constructor(
    public readonly value: T,
    public readonly status: AttentionStatusType,
    public readonly ruleName: EvaluationRule['calculationProperty']
  ) {}

  static from<T extends Printable>(
    status: AttentionStatusType,
    value: T,
    ruleName: EvaluationRule['calculationProperty']
  ): EvaluationResultType<T> {
    return new EvaluationResult(value, status, ruleName);
  }

  public toEvaluatedResult(): EvaluatedResult<T> {
    return { value: this.value, status: this.status };
  }
}
